
const state = {

    popups: [],

    loaderVisible: false

};

const getters = {

    popups(state) {
        return state.popups;
    },

    loaderVisible(state) {
        return state.loaderVisible;
    }

};

const mutations = {

    $openAlert(state, payload) {
        state.popups.push({
            alert: payload
        });
    },

    $openPopup(state, payload) {
        // adds the popup
        state.popups.push({
            popup: payload.popup,
            data: payload.data,
            handler: payload.handler
        });
    },

    $closePopup(state, payload) {
        // removes the last popup
        state.popups.splice(-1, 1);
    },

    showLoader(state) {
        state.loaderVisible = true;
    },

    hideLoader(state) {
        state.loaderVisible = false;
    }

};

const actions = {

};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/popup.js